import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { keyBy, uniqBy } from 'lodash';

import './index.scss';
import CommonTable from '../../common/table';
import {
  REDUCER_NAME,
  fetchAggregatorNews,
  fetchAggregatorNewsInterval,
  resetStoreData,
  setAPIParams,
} from '../../reducer';
import Const from '../../Const';
import { getDataFollowKeyByDot } from '../../../helpers/Common';

const INTERVAL_TIME = 300000;

class NewsAggregator extends React.Component {
  componentDidMount() {
    const {
      fetchAggregatorNews,
      resetStoreData,
      fetchAggregatorNewsInterval,
    } = this.props;
    resetStoreData('aggregatorNewsData');
    fetchAggregatorNews();

    this.intervalId = setInterval(() => {
      fetchAggregatorNewsInterval();
    }, INTERVAL_TIME);
  }

  componentDidUpdate(prevProps) {
    const { fetchAggregatorNews, resetStoreData } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      resetStoreData('aggregatorNewsData');
      fetchAggregatorNews();
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  transformData = (data, filterCondition) => {
    if (Object.keys(filterCondition).length) {
      const filteredData = data.filter(function(item) {
        for (var key in filterCondition) {
          if (key === Const.SOURCE_CODE) {
            return true;
          }
          if (item[key] === undefined || item[key] !== filterCondition[key])
            return false;
        }
        return true;
      });

      return filteredData;
    }
    return data;
  };

  render() {
    const {
      aggregatorNewsData: {
        data,
        isLoading,
        filterCondition,
        isShortByFavorite,
        storeName,
      },
      aggregatorNewsData,
    } = this.props;

    const filteredData = this.transformData(data, filterCondition);
    //data with condition
    const listIdsInLocalStore =
      JSON.parse(localStorage.getItem(storeName)) || [];
    //data in Local Store
    const uniqueIds = uniqBy(listIdsInLocalStore, e => {
      return e;
    });
    // make list unique
    const listFullData = keyBy(filteredData, Const.NewsAggregatorTable.ID);
    const listIds = filteredData.map(item =>
      getDataFollowKeyByDot(item, Const.NewsAggregatorTable.ID),
    );
    const idsInCurrentList = uniqueIds.filter(id => listIds.includes(id));

    const optProps = isShortByFavorite
      ? {
          isGroupData: true,
          ids: idsInCurrentList,
        }
      : {
          ids: listIds,
        };

    return (
      <CommonTable
        dateKey="publicDate"
        listColumn={Const.NewsAggregatorTable}
        list={listFullData}
        isLoading={isLoading}
        isShortByFavorite={isShortByFavorite}
        type="na"
        commonData={aggregatorNewsData}
        {...optProps}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    aggregatorNewsData: state[REDUCER_NAME].aggregatorNewsData,
    currentTab: state[REDUCER_NAME].currentTab,
    currentChildTab: state[REDUCER_NAME].currentChildTab,
  };
};

const mapDispatchToProps = {
  fetchAggregatorNews,
  fetchAggregatorNewsInterval,
  resetStoreData,
  setAPIParams,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  NewsAggregator,
);
